{
  "de": {
    "worksheet": {
      "autoSave": {
        "saved": "Änderungen gespeichert",
        "saveFailed": "Änderungen konnten nicht gespeichert werden",
        "sessionExpired": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an, um Änderungen zu speichern.",
        "draftRestoreFailed": "Entwurf konnte nicht wiederhergestellt werden"
      },
      "submitFailed": "Abgabe fehlgeschlagen. Bitte versuche es erneut.",
      "aiGenerator": {
        "breadcrumbs": {
          "course": "Kurs",
          "knowledge": "Wissen",
          "topic": "Thema"
        },
        "buttons": {
          "createWorksheet": "Arbeitsblatt erstellen",
          "creating": "Verarbeitung läuft …"
        },
        "course": {
          "grade": "Klassenstufe",
          "language": "Sprache",
          "school": "Schulform",
          "subject": "Schulfach"
        },
        "errors": {
          "generationFailed": "Das Arbeitsblatt konnte nicht erstellt werden. Bitte versuche es erneut."
        },
        "headers": {
          "createTitle": "Arbeitsblatt mit KI-Assistenz erstellen"
        },
        "knowledge": {
          "subtitle": "Optional kannst du eine Quelle hinzufügen, aus der die KI das Hintergrundwissen für das Arbeitsblatt extrahiert."
        },
        "labels": {
          "languageLevel": "Sprachniveau (GER) auswählen",
          "learningObjectiveHeading": "Lernziel für dieses Arbeitsblatt",
          "topicHeading": "Thema oder Fragestellung für dieses Arbeitsblatt"
        },
        "placeholders": {
          "learningObjectiveHeading": "Welche Kompetenzen sollen aufgebaut werden? (z. B. Analyse und Beurteilung der Startbedingungen der Weimarer Republik).",
          "topicHeading": "Welche Hauptthemen soll das Arbeitsblatt behandeln? (z. B. „Der Beginn der Weimarer Republik“)"
        },
        "tooltips": {
          "generateLearningObjectives": "Lernziele mit KI vorschlagen lassen",
          "generateLearningObjectivesDisabled": "Gib zuerst ein Thema ein, um Lernziele vorschlagen zu lassen"
        }
      },
      "aiPromptModal2": {
        "headers": {
          "title": "Textaufgabe mit KI generieren"
        },
        "labels": {
          "prompt": "Anforderungen"
        },
        "placeholders": {
          "prompt": "Beschreibe den Fokus der Aufgabe und gib ggf. eine Leitfrage oder Lernziel an."
        },
        "description": "Was möchtest du erstellen?"
      },
      "aiGeneration": {
        "createWithAi": "Mit KI erstellen",
        "dropdownLabel": "KI-Optionen zum Generieren",
        "pending": "KI erstellt Inhalt...",
        "menu": {
          "newVariant": "Inhalt variieren",
          "harder": "Schwierigere Aufgabe",
          "easier": "Einfachere Aufgabe",
          "addHelp": "Hinweise ergänzen",
          "simpleLanguage": "Einfache Sprache",
          "custom": "Eigene Anfrage"
        },
        "prompts": {
          "newBlock": "Erstelle einen passenden {blockType}-Block als nächsten sinnvollen Schritt in diesem Arbeitsblatt.",
          "newVariant": "Erstelle eine Variante dieses Blocks: Wechsle Kontext, Zahlen oder Formulierung so, dass die Aufgabe nicht aus Erinnerung an das Original lösbar ist. Lernziel und Schwierigkeit bleiben gleich.",
          "harder": "Mache diesen Block anspruchsvoller, indem du mehr Denkleistung verlangst – nicht mehr Arbeit.",
          "easier": "Mache diesen Block leichter: Vereinfache Sprache und Struktur und entferne unnötige Informationen. Lernziel und Fachbegriffe bleiben – erkläre Fachbegriffe, statt sie zu ersetzen.",
          "addHelp": "Ergänze hilfreiche Hinweise, Zwischenschritte oder Beispiele, ohne die Lösung vorwegzunehmen.",
          "simpleLanguage": "Formuliere diesen Block in einfacher Sprache. Behalte Fachbegriffe aus Lernziel und Block bei und erkläre sie bei Bedarf.",
          "guidance": {
            "fillInTheBlank": "Für Lückentext: Fülle Beschreibung und Lückentext; variiere die Lücken passend zur Anfrage."
          }
        }
      },
      "aiContext": {
        "title": "KI-Einstellungen Arbeitsblatt",
        "button": "KI-Einstellungen",
        "description": "Bestimme hier, für wen das Arbeitsblatt ist. Mit diesen Informationen kann die KI besser Aufgaben für dich erstellen.",
        "sections": {
          "schoolDetails": {
            "title": "Schulische Eckdaten"
          },
          "backgroundKnowledge": {
            "title": "Hintergrundwissen"
          }
        },
        "labels": {
          "subjectTypes": "Schulfach",
          "schoolTypes": "Schulform",
          "gradeLevels": "Klassenstufe",
          "locale": "Sprache",
          "addBackgroundKnowledge": "Hintergrundwissen hinzufügen"
        },
        "descriptions": {
          "addBackgroundKnowledge": "Füge Hintergrundwissen aus verschiedenen Quellen hinzu, zum Beispiel per Dateiupload sowie aus Webseiten, YouTube-Videos, Audiodateien oder Videos."
        },
        "actions": {
          "removeSource": "Quelle entfernen"
        },
        "hints": {
          "hasSources": "Quellen vorhanden"
        },
        "sourceKinds": {
          "text": "Text",
          "file": "Datei",
          "pdf": "PDF",
          "image": "Bild",
          "website": "Webseite",
          "youtube": "YouTube",
          "audio": "Audio",
          "video": "Video"
        },
        "flash": {
          "saveFailed": "KI-Einstellungen konnten nicht gespeichert werden"
        },
        "sourcePicker": {
          "title": "Hintergrundwissen hinzufügen",
          "subtitle": "Wähle eine Quelle aus und die KI extrahiert davon den Text als Hintergrundwissen für das Arbeitsblatt."
        },
        "recent": {
          "empty": "Noch keine Quellen vorhanden. Füge zuerst Hintergrundwissen hinzu.",
          "error": "Die zuletzt verwendeten Quellen konnten nicht geladen werden."
        }
      },
      "blockTypes": {
        "Divider": "Trennlinie",
        "File": "Datei",
        "FillInTheBlankText": "Lückentext",
        "H5p": "H5P",
        "Hint": "Tipp",
        "Image": "Bild",
        "MultipleChoice": "Multiple Choice",
        "SingleChoice": "Single Choice",
        "Spacer": "Abstand",
        "PageBreak": "Seitenumbruch",
        "StaticText": "Text",
        "Text": "Textantwort",
        "Upload": "Datei Anfordern",
        "Video": "Video",
        "ToTeachExercise": "to teach Übung"
      },
      "blockTypesV2": {
        "Upload": "Datei Anfordern",
        "ToTeachExercise": "to teach Übung"
      },
      "inserterHints": {
        "toTeachExercise": "Neu: Verwende deine Inhalte von to teach in deinen fobizz Arbeitsblättern.",
        "pageBreak": "Neu: Fokussiere die Ansicht durch Seitenumbrüche."
      },
      "navigation": {
        "headline": "Dein Fortschritt",
        "previousPage": "Zurück",
        "nextPage": "Nächste Seite"
      },
      "buttons": {
        "addOption": "Option hinzufügen",
        "submit": "Abgeben",
        "confirmDelete": "Ja, löschen",
        "duplicate": "Duplizieren",
        "generate": "Generieren",
        "deleteResponse": "Abgabe löschen",
        "moveDown": "Runter schieben",
        "moveUp": "Hoch schieben",
        "remove": "Entfernen",
        "removeOption": "Option entfernen"
      },
      "elements": "Elemente",
      "addNewBlock": "Neuen Block hinzufügen",
      "multimedia": "Multimedia",
      "layout": "Layout",
      "feedback": {
        "form": {
          "actions": {
            "reset": {
              "label": "Feedback löschen",
              "message": {
                "success": "Feedback gelöscht"
              }
            },
            "submit": {
              "label": "Feedback speichern",
              "message": {
                "error": "Feedback konnte nicht gespeichert werden",
                "success": "Feedback gespeichert"
              }
            }
          },
          "fieldset": {
            "text": {
              "label": "Textnachricht schreiben"
            }
          },
          "headline": "Individuelles Feedback geben"
        },
        "public": {
          "headline": "Feedback von {name} zu deiner Abgabe"
        },
        "shareLinkBox": "Link zur Abgabe mit Feedback teilen",
        "status": {
          "hasFeedback": "Feedback gegeben"
        }
      },
      "fillInTheBlankDefault": {
        "answerOption": "Dies ist ein Beispiel für einen Lückentext mit einer {'{'} Lücke {'}'}. Es können {'{'} viele/mehrere/verschiedene {'}'} Antwortmöglichkeiten angegeben werden. In diesem Fall wäre im ersten Satz 'Lücke' die korrekte Antwort. Im zweiten Satz wären sowohl 'viele' als auch 'mehrere' und 'verschiedene' richtig.'",
        "description": "Dein Beschreibungstext mit Hinweisen zur Bearbeitung (nicht der Lückentext). Du kannst hier auch Lösungsvorschläge zur Zuordnung anbieten, bspw. so: 'Fülle den Lückentext mit folgenden Begriffen aus: <i><mark>Wort 1</mark></i>, <i><mark>Wort 2</mark></i>...'"
      },
      "fillInTheBlankEditor": {
        "descriptionLabel": "Beschreibungstext",
        "descriptionHint": "Nutze den Beschreibungstext für Bearbeitungshinweise. Du kannst hier auch Lösungsvorschläge zur Zuordnung anbieten. Zum Beispiel {italic}",
        "descriptionHintItalic": "\"Fülle den Lückentext mit folgenden Begriffen aus: Deutschland, Bundesland, Republik,...\"",
        "clozeLabel": "Lückentext",
        "clozeHint": "\"Beispiel für einen Lückentext mit einer <strong>{'{'} Lücke {'}'}</strong>. Es können <strong>{'{'} viele/mehrere {'}'}</strong> Antworten festgelegt werden.\" In diesem Fall wäre 'Lücke' die korrekte Antwort und im zweiten Satz wären 'viele' als auch 'mehrere' richtig.",
        "insertGap": "Lücke einfügen"
      },
      "flash": {
        "addOptionSuccess": "Option hinzugefügt",
        "createBlockSuccess": "Block hinzugefügt",
        "createSolutionSuccess": "Lösung hinzugefügt",
        "deleteBlockSuccess": "Block gelöscht",
        "duplicateBlockSuccess": "Block dupliziert",
        "deleteOptionSuccess": "Option entfernt",
        "deleteSolutionSuccess": "Lösung gelöscht",
        "moveBlockSuccess": "Block verschoben",
        "updateBlockSuccess": "Block aktualisiert",
        "updateClozeTestSuccess": "Lückentext aktualisiert",
        "updateOptionSuccess": "Option aktualisiert",
        "updateSolutionSuccess": "Lösung aktualisiert",
        "updateWorksheetSuccess": "Arbeitsblatt aktualisiert",
        "updateWorksheetError": "Arbeitsblatt konnte nicht aktualisiert werden"
      },
      "headings": {
        "saveShareLink": "Merke dir diesen Link, damit du deine Ergebnisse später einfach wiederfindest."
      },
      "hints": {
        "Divider": "Nutze die Trennlinie, um das Arbeitsblatt visuell zu strukturieren und einen Bereich vom darauf folgenden abzugrenzen.",
        "File": "Füge hier Arbeitsmaterial (z. B. eine Textdatei, ein Bild oder eine PDF) ein, das deine Schüler*innen sich herunterladen oder anschauen sollen. Tipp: Nutze den Upload-Aufgabenblock, um die bearbeitete Datei direkt von deinen Schüler*innen wieder einzusammeln.",
        "FillInTheBlankText": "Schreibe einen Lückentext oder eine Frage mit einer einzigen Antwortlücke. Verwende die Symbole {'{'} und {'}'}, um eine Lücke zu markieren und die möglichen Lösungswörter zu umschließen. Wenn mehr als nur ein Wort richtig sein kann, trenne die Lösungswörter mit einem /. Ein Beispielsatz könnte lauten: \"Die Schülerinnen und Schüler müssen {'{'}eine/die{'}'} Lücke ausfüllen.\" Hier ist sowohl 'eine' als auch 'die' eine richtige Antwort. Alle Antworten werden direkt ausgewertet.",
        "H5p": "Binde interaktive H5P-Inhalte in dein Arbeitsblatt ein. Lade eine .h5p-Datei hoch, um interaktive Übungen, Quizzes und Lernspiele zu erstellen.",
        "Hint": "Gib deinen Schüler*innen extra Tipps mit diesem visuell hervorgehobenen Text-Hinweis.",
        "Image": "Füge ein Bild aus der Bildersuche hinzu oder lade ein eigenes Bild hoch, um dein Arbeitsblatt mit visuellem Inhalt anzureichern.",
        "MultipleChoice": "Stelle eine Frage und trage die Antwortmöglichkeiten ein. Markiere die korrekten Antworten mit Klick auf den Kreis davor. Die Auswertung zeigt dir direkt, bei welchen Aufgaben bei deinen Schüler*innen die größte Sicherheit – oder der größte Wiederholungsbedarf – besteht.",
        "SingleChoice": "Stelle eine Frage und trage die Antwortmöglichkeiten ein. Markiere die korrekte Antwort mit Klick auf den Kreis davor. Die Auswertung zeigt dir direkt, bei welchen Aufgaben bei deinen Schüler*innen die größte Sicherheit – oder der größte Wiederholungsbedarf – besteht.",
        "Spacer": "Füge deinem Arbeitsblatt Abstände hinzu, um die Inhalte übersichtlicher zu gestalten.",
        "PageBreak": "Nutze den Seitenumbruch, um das Arbeitsblatt in mehrere Seiten aufzuteilen, zwischen denen navigiert werden kann.",
        "StaticText": "Nutze das Textelement, um deinen Schüler*innen Erklärungen, Hinweise und zusätzliche Infos zum Bearbeiten der Aufgaben zu geben. Hinweis: hier können deine Schüler*innen - anders als bei den Abfrageblöcken - nichts digital ausfüllen.",
        "Text": "Verfasse einen Arbeitsauftrag, für den deine Schüler*innen eine Antwort in einem Textfeld digital einreichen können.",
        "Upload": "Formuliere einen Arbeitsauftrag, für den deine Schüler*innen eine Datei hochladen sollen (z. B. eine Textdatei, ein Bild oder eine PDF). Du kannst später alle eingereichten Dateien an einem Ort übersichtlich auswerten.",
        "ToTeachExercise": "Suche nach interaktiven Übungen von to teach und binde sie direkt in dein Arbeitsblatt ein.",
        "Video": "Bette YouTube- oder Vimeo-Videos per Link ein (z. B.: https://vimeo.com/469669139).",
        "answered": "beantwortet",
        "dragNDrop": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen",
        "dropFileHere": "Datei hier hineinziehen oder Datei auswählen",
        "dropH5pFileHere": "H5P-Datei hier hineinziehen oder",
        "uploadH5pFilePrompt": "H5P-Datei hier hineinziehen oder Datei auswählen",
        "elements": "Binde Erklärungen und Inhalte für deine Schüler*innen ein und strukturiere dein Arbeitsblatt.",
        "h5pContentStatus": "Status: {status}",
        "h5pFileRequirement": "Nur .h5p-Dateien sind erlaubt",
        "h5pProcessing": "H5P-Inhalt wird verarbeitet, bitte warten...",
        "h5pProcessingFailed": "H5P-Verarbeitung fehlgeschlagen. Bitte versuche es erneut.",
        "h5pProcessingStalled": "Die Verarbeitung dieses H5P-Inhalts dauert ungewöhnlich lange. Bitte versuche es später erneut oder kontaktiere den Support.",
        "h5pReloadHint": "Inhalte werden nicht angezeigt? Seite neu laden",
        "h5pFileUploadSuccess": "H5P-Datei erfolgreich hochgeladen.",
        "h5pPreviewHint": "In der Vorschau kannst du das Modul ausprobieren.",
        "toTeachExerciseImportSuccess": "to teach Übung erfolgreich importiert.",
        "maxOptionsReached": "Maximal {max} Optionen können hinzugefügt werden.",
        "name": "Trage hier dein Pseudonym oder Namenskürzel ein.",
        "noDescriptionOrCloze": "Keine Beschreibung und kein Lückentext hinterlegt",
        "emptyBlock": "<strong>Dieser Block ist leer.</strong> Er erscheint weder in der Vorschau noch in der Ansicht für Schüler:innen.",
        "noDescriptionOrOptions": "Keine Beschreibung oder Optionen hinterlegt",
        "fileUploadSuccess": "Datei erfolgreich hochgeladen.",
        "noFile": "Keine Datei hochgeladen",
        "noH5pContent": "Keine H5P-Inhalte hochgeladen",
        "h5pNotPrintable": "Dieser interaktive Inhalt kann nicht gedruckt werden.",
        "noHint": "Kein Tipp eingegeben",
        "noImage": "Kein Bild hochgeladen",
        "noInput": "Keine Angabe",
        "selectFile": "Datei auswählen",
        "noSolution": "Keine Lösung hinterlegt",
        "noText": "Kein Text eingegeben",
        "noVideo": "Kein Video eingebettet",
        "processingH5pFile": "H5P-Datei wird verarbeitet...",
        "questions": "Erstelle Aufgaben mit Feldern, die deine Schüler*innen ausfüllen können.",
        "submitSuccessful": "Vielen Dank! Du hast dein Arbeitsblatt erfolgreich abgegeben.",
        "searchToTeachExercises": "to teach Übungen suchen...",
        "processingToTeachExercise": "to teach Übung wird importiert und verarbeitet...",
        "noToTeachExercisesFound": "Keine Übungen gefunden",
        "noToTeachExercise": "Keine to teach Übung ausgewählt",
        "toTeachSsoNotLinked": "Dein Konto ist noch nicht mit to teach verknüpft. Verbinde dein Konto, um deine to teach Inhalte bei fobizz zu nutzen. <a href=\"https://to-teach.ai/auth/fobizz\" target=\"_blank\" rel=\"noopener noreferrer\">Zu to teach</a>",
        "videoError": "Die eingegebene URL ist ungültig. Gib eine korrekte Adresse ein oder lösche deine Eingabe.",
        "videoExample": "Beispiel: https://vimeo.com/469669139"
      },
      "labels": {
        "clozeGap": "Lücke {current} von {total}",
        "confirmDeleteBlock": "Block löschen?",
        "confirmDeleteBlockText": "Achtung: Wenn du diesen Block entfernst, werden alle ggf. damit verbundenen Abgaben ebenfalls gelöscht.",
        "confirmDeleteResponse": "Abgabe wirklich löschen?",
        "confirmDeleteResponseText": "Soll die Abgabe wirklich gelöscht werden?",
        "confirmSubmitIncompleteResponse": "Es sind noch nicht alle Aufgaben bearbeitet. Möchtest du das Arbeitsblatt trotzdem abgeben?",
        "confirmSubmitResponse": "Möchtest du das Arbeitsblatt jetzt abgeben?",
        "confirmSubmitResponseTitle": "Arbeitsblatt abgeben?",
        "confirmSubmitKeepEditing": "Weiter bearbeiten",
        "confirmSubmitAnyway": "Ja, abgeben",
        "draft": "Entwurf | Entwürfe",
        "response": "Abgabe | Abgaben",
        "responseStatus": {
          "draft": "In Bearbeitung",
          "submitted": "Abgeschlossen"
        },
        "respondingAs": "Du beantwortest dieses Arbeitsblatt als {pseudonym}",
        "responsesTab": "Entwürfe und Abgaben",
        "worksheet": "Arbeitsblatt"
      },
      "links": {
        "shareResponse": "Zugangslink kopieren",
        "showResponseSolutionToggle": "Zeige Musterlösungen",
        "taskNo": "{ index }. Aufgabe"
      },
      "placeholders": {
        "FillInTheBlankText": "Lückentext hier eingeben",
        "answerInput": "Antwort hier eingeben",
        "clickToEdit": "Klicken zum Bearbeiten",
        "description": "Beschreibung hier eingeben",
        "hint": "Tipp hier eingeben",
        "imageCaption": "Bildunterschrift hier eingeben",
        "optionInput": "Option hier eingeben",
        "videoCaption": "Videounterschrift hier eingeben",
        "videoUrl": "Video-URL eingeben"
      },
      "questions": "Abfragen",
      "solution": {
        "actions": {
          "add": "Musterlösung hinzufügen",
          "delete": "Musterlösung entfernen",
          "showResponseSolution": "Alle Lösungen nach Abgabe anzeigen"
        },
        "hints": {
          "showResponseSolution": "Deine Schüler*innen sehen die hinterlegten Musterlösungen direkt nach der Abgabe."
        },
        "title": "Musterlösung",
        "types": {
          "text": {
            "placeholder": "Musterlösung hier eingeben..."
          }
        }
      },
      "words": {
        "of": "von"
      }
    }
  }
}
